import React, { FC, useMemo, PropsWithChildren } from 'react';

import queryString from 'query-string';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

import { useMetaQuery } from '~/redux/ducks/metaData';

const MILESTONES = 'milestones';
const RECORDS = 'records';

const formatMetaPathInput = (path: string) => {
    const pathParts = path.toLowerCase().split('/');

    if (pathParts.length === 0) {
        return '';
    } else if (pathParts.length === 1) {
        return '/';
    } else if (pathParts.length === 2) {
        return pathParts[1];
    } else if (pathParts.length > 2) {
        if (pathParts[1] === RECORDS) {
            return `${pathParts[1]}/${pathParts[2]}${pathParts[2] === MILESTONES ? '/' + pathParts[3] : ''}`;
        }
        return path.slice(1);
    }

    return path;
};

const MetaHelmet: FC<PropsWithChildren> = ({ children }) => {
    const location = useLocation();
    const query = queryString.parse(location.search);
    const season = query.season;
    const formattedPath = formatMetaPathInput(location.pathname);

    const params = useMemo(() => ({ formattedPath, season }), [formattedPath, season]);
    let { data: metaData = [] } = useMetaQuery(params);
    const hasMetaData = metaData.length > 0;
    const title = hasMetaData
        ? `${metaData[0].title} | ${window.recordsSettings.basePageTitle}`
        : `${window.recordsSettings.basePageTitle}`;
    const description = hasMetaData ? metaData[0].description : '';

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            {children}
        </Helmet>
    );
};

export default MetaHelmet;
